import { Component, Vue } from 'vue-property-decorator';
import WithRender from './stockorders.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    Datepicker
  }
})
export default class StockOrders extends Vue {
  isLoading = false;
  fromDate = moment().subtract(30, 'days').toDate();
  toDate = new Date();
  merchantReference = '';
  statusValue = 'unfulfilled';
  statusOptions = [
    { value: 'unfulfilled', text: 'Not fulfilled' },
    { value: 'fulfilled', text: 'Fulfilled' },
    { value: 'all', text: 'All' }
  ]

  perPage = 10;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  items = [];
  fields = [
    {
      key: "merchantReference",
      label: "Order Reference",
      sortable: true
    },
    {
      key: "createdOn",
      label: "Ordered On",
      sortable: true,
    },
    {
      key: "orderedBy",
      label: "Ordered By",
      sortable: true,
    },
    {
      key: "deliveryAddress",
      label: "Deliver To",
      sortable: false,
    },
    {
      key: "items",
      label: "Items",
      sortable: false,
    },
    {
      key: "totalAmount",
      label: "Total",
      sortable: true,
    },
    {
      key: "fulfilled",
      label: "Status",
      sortable: true,
    },
    {
      key: "action",
      label: "",
      sortable: false,
    }
  ]

  customFormatter(date: Date) {
    return moment(date).format('yyyy-MM-DD');
  }

  mounted() {
    this.getStockOrders();
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getStockOrders()
  }

  getStockOrders(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/StockOrder?&currentPage=${this.currentPage}
      &PageSize=${this.perPage}
      &DateFrom=${this.customFormatter(this.fromDate)}
      &DateTo=${this.customFormatter(this.toDate)}
      &status=${this.statusValue}
      &merchantReference=${this.merchantReference}`)
      .then(response => {
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => {
        console.error(err);
        const status = (err.response && err.response.status) || '';
        const detail = (err.response && err.response.data) || err.message || '';
        alert(`Could not load stock orders: ${status} ${detail}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  markFulfilled(order: any): void {
    const fulfilledBy = window.prompt('Fulfilled by (your name):');
    if (!fulfilledBy)
      return;

    const notes = window.prompt('Notes (optional e.g delivered by courier):') || '';

    this.isLoading = true;
    _axios.post(`${config.gateway}admin/internal/report/StockOrder/fulfil`, {
      paymentDetailId: order.paymentDetailId,
      fulfilledBy: fulfilledBy,
      notes: notes
    })
      .then(() => {
        this.getStockOrders();
      })
      .catch(err => {
        console.error(err);
        this.isLoading = false;
      });
  }
}
